export default "__VITE_ASSET__CodaNtNv__"